import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import AnimatedModal from "../../ReusableComponents/AnimatedModal";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import SparkleIcon from "../assets/icons/SparkleIcon.svg";
import { createImageCollection, createNewProject } from "../../api";
import { Snackbar, Alert } from "@mui/material";
import { getPicstorkDefaultPlan } from "../../ReusableComponents/reusableFunctions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const CreateTower = ({ isOpen, onRequestClose, onSubmit }) => {
  const TOWER_TYPES = [
    { label: "Suspension", value: "Suspension" },
    { label: "Tension", value: "Tension" },
    { label: "Terminal", value: "Terminal" },
  ];

  const [formData, setFormData] = useState({
    towerName: "",
    totalTowers: "",
    location: "",
    capacity: "",
    unit: "",
    towerType: "",
    otherType: "",
    height: "",
    span: "",
    description: "",
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isUnitDropdownOpen, setIsUnitDropdownOpen] = useState(false);

  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success", // "success" | "error" | "info" | "warning"
  });

  const [successModal, setSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      service: "AEROCAPTURE",
      industry_name: "Tower",
      projectDetails: {
        projectName: formData.towerName?.trim() || null,
        locationName: formData.location?.trim() || null,
        description: formData.description?.trim() || null,
        towerType: formData.towerType || formData.otherType || null,
        towerHeight:
          formData.height && !isNaN(formData.height)
            ? Number(formData.height)
            : null,
        towerLength:
          formData.span && !isNaN(formData.span) ? Number(formData.span) : null,
        capacity:
          formData.capacity && !isNaN(formData.capacity)
            ? Number(formData.capacity)
            : null,
        capacityUnit: formData.unit || null,
        totalTowers:
          formData.totalTowers && !isNaN(formData.totalTowers)
            ? Number(formData.totalTowers)
            : null,
      },
    };

    try {
      const res = await createNewProject(payload);

      if (res.message === "OK") {
        const project = res.project;

        // let plan = null;
        // try {
        //   plan = await getPicstorkDefaultPlan(project);
        //   console.log("Default plan created:", plan);
        // } catch (planErr) {
        //   console.error("Failed to create default plan:", planErr);
        // }

        // if (plan && plan.id) {
        //   try {
        //     await createImageCollection(
        //       project.id,
        //       plan.id,
        //       `${project.project_name} images`
        //     );
        //   } catch (imgErr) {
        //     console.error("Failed to create image collection:", imgErr);
        //   }
        // }

        onSubmit(project);
        onRequestClose();

        setSuccessModal(true);
        setTimeout(() => setSuccessModal(false), 2500);
      } else {
        console.log(res || "Something went wrong.");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setFormData({
        towerName: "",
        location: "",
        totalTowers: "",
        capacity: "",
        unit: "",
        towerType: "",
        otherType: "",
        height: "",
        span: "",
        description: "",
      });
      setIsDropdownOpen(false);
      setIsUnitDropdownOpen(false);
    }
  }, [isOpen]);

  return (
    <>
      <AnimatedModal
        isOpen={successModal}
        onRequestClose={() => setSuccessModal(false)}
        width="fit-conetent"
        height="auto"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "1.5rem",
            transform: "scale(1)",
            opacity: 1,
            transition: "all 0.3s ease-out",
          }}
        >
          <CheckCircleIcon
            style={{
              fontSize: 50,
              color: "#4CAF50",
              marginBottom: "10px",
              transform: "scale(1.1)",
              transition: "transform 0.3s ease-in-out",
            }}
          />
          <h2
            style={{
              marginTop: "0.5rem",
              fontSize: "1.25rem",
              fontWeight: "600",
              color: "#333",
            }}
          >
            Project Created Successfully!
          </h2>
        </div>
      </AnimatedModal>

      <AnimatedModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        width="35%"
        height="auto"
      >
        <div className="create-tower-container">
          <div className="create-tower-header">
            <p className="create-tower-title">Add New Project</p>
            <button onClick={onRequestClose} className="create-tower-close">
              ✕
            </button>
          </div>

          <div className="create-tower-form">
            {/* Tower Name */}
            <label className="create-tower-label">Tower Name</label>
            <input
              type="text"
              name="towerName"
              placeholder="Enter name"
              value={formData.towerName}
              onChange={handleChange}
              className="create-tower-input"
            />

            {/* KML File */}
            {/* <label className="create-tower-label">KML File</label>
            <input
              type="text"
              name="location"
              placeholder="Enter location"
              value={formData.location}
              onChange={handleChange}
              className="create-tower-input"
            /> */}

            <label className="create-tower-label">Total Towers</label>
            <input
              type="text"
              name="totalTowers"
              placeholder="e.g. 250"
              value={formData.totalTowers}
              onChange={handleChange}
              className="create-tower-input"
            />

            {/* Capacity & Unit */}
            {/* <div className="create-tower-row">
              <div className="create-tower-col">
                <label className="create-tower-label">
                  Transmission Capacity
                </label>
                <input
                  type="number"
                  name="capacity"
                  placeholder="e.g. 100"
                  value={formData.capacity}
                  onChange={handleChange}
                  className="create-tower-input"
                />
              </div>

              <div className="create-tower-col">
                <label className="create-tower-label">Unit</label>
                <Dropdown
                  onSelect={(val) =>
                    setFormData((prev) => ({ ...prev, unit: val }))
                  }
                  onToggle={(isOpen) => setIsUnitDropdownOpen(isOpen)}
                >
                  <Dropdown.Toggle
                    variant="secondary"
                    bsPrefix="custom-toggle"
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      background: "#f2f2f2",
                      border: "2px solid #E5E7EB",
                      borderRadius: "5px",
                      fontSize: "12px",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      color: formData.unit ? "#333" : "#89889E",
                      textAlign: "start",
                      outline: "none",
                      boxShadow: "none",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>{formData.unit || "Select Unit"}</span>
                    {isUnitDropdownOpen ? (
                      <KeyboardArrowUp
                        fontSize="small"
                        style={{ color: "#89889E" }}
                      />
                    ) : (
                      <KeyboardArrowDown
                        fontSize="small"
                        style={{ color: "#89889E" }}
                      />
                    )}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                      width: "100%",
                      padding: 0,
                    }}
                  >
                    <Dropdown.Item
                      eventKey="KV"
                      style={{
                        fontSize: "12px",
                        color: "#222",
                        padding: "8px 10px",
                      }}
                    >
                      KV (kilowatt)
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="MV"
                      style={{
                        fontSize: "12px",
                        color: "#222",
                        padding: "8px 10px",
                      }}
                    >
                      MV (megawatt)
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="GW"
                      style={{
                        fontSize: "12px",
                        color: "#222",
                        padding: "8px 10px",
                      }}
                    >
                      GW (gigawatt)
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div> */}

            {/* Tower Type */}
            {/* <label className="create-tower-label">Tower Type</label>
            <Dropdown
              onSelect={(val) =>
                setFormData((prev) => ({ ...prev, towerType: val }))
              }
              onToggle={(isOpen) => setIsDropdownOpen(isOpen)}
            >
              <Dropdown.Toggle
                variant="secondary"
                bsPrefix="custom-toggle"
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  marginBottom: "14px",
                  background: "#f2f2f2",
                  border: "2px solid #E5E7EB",
                  borderRadius: "5px",
                  fontSize: "12px",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  color: formData.towerType ? "#333" : "#89889E",
                  textAlign: "start",
                  outline: "none",
                  boxShadow: "none",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>
                  {formData.towerType
                    ? TOWER_TYPES.find((t) => t.value === formData.towerType)
                        ?.label
                    : "Select type"}
                </span>
                {isDropdownOpen ? (
                  <KeyboardArrowUp
                    fontSize="small"
                    style={{ color: "#89889E" }}
                  />
                ) : (
                  <KeyboardArrowDown
                    fontSize="small"
                    style={{ color: "#89889E" }}
                  />
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  width: "100%",
                  padding: 0,
                }}
              >
                {TOWER_TYPES.map((type) => (
                  <Dropdown.Item
                    key={type.value}
                    eventKey={type.value}
                    style={{
                      fontSize: "12px",
                      color: "#222",
                      padding: "8px 10px",
                    }}
                  >
                    {type.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown> */}

            {/* <input
              type="text"
              name="otherType"
              placeholder="Other"
              value={formData.otherType}
              onChange={handleChange}
              className="create-tower-input"
            /> */}

            {/* Height & Span */}
            {/* <div className="create-tower-row">
              <div className="create-tower-col">
                <label className="create-tower-label">Tower Height (m)</label>
                <input
                  type="number"
                  name="height"
                  placeholder="e.g. 50m"
                  value={formData.height}
                  onChange={handleChange}
                  className="create-tower-input"
                />
              </div>
              <div className="create-tower-col">
                <label className="create-tower-label">Span Length (m)</label>
                <input
                  type="number"
                  name="span"
                  placeholder="e.g. 200m"
                  value={formData.span}
                  onChange={handleChange}
                  className="tower-length-input"
                />
                <p style={{ fontSize: "9px" }}>
                  Note: Enter span length (distance between two towers) in
                  meters.
                </p>
              </div>
            </div> */}

            {/* Description */}
            <label className="create-tower-label">Description</label>
            <textarea
              name="description"
              placeholder="Enter description"
              value={formData.description}
              onChange={handleChange}
              className="create-tower-input"
            />
            {/* <p className="rewrite-ai-badge">
              <img
                src={SparkleIcon}
                alt="Sparkle Icon"
                className="w-4 h-4 mr-2"
              />
              Rewrite with AI
            </p> */}
          </div>

          <div className="create-tower-footer">
            <button onClick={handleSubmit} className="create-tower-submit">
              Add
            </button>
          </div>
        </div>
      </AnimatedModal>

      {/* Snackbar Toast */}
      {/* <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setToast({ ...toast, open: false })}
          severity={toast.severity}
          variant="filled"
        >
          {toast.message}
        </Alert>
      </Snackbar> */}
    </>
  );
};

export default CreateTower;
